export const quoteErrorKey = (error: any) => {
  const data = error?.response?.data;
  if (data?.missing_settings?.some((row: any) => (row.material === false || row.material === "False") && row.processing === "unit")) return "order.missingUnitRate";
  return data?.missing_prices ? "order.missingConfiguration" : "order.generationFailed";
};
